import { CallApi, handleJSONResponse } from "./common";
import { PageResult } from "../../../../common/types/api/page-result";
import { AdminRelease } from "../../../../services/release-admin/types/admin-release";
import { AdminReleaseStatus } from "../../../../services/release-admin/types/admin-release-status";
import { ReleaseChangelog, ReleaseChangelogResp } from "../../../../services/release-admin/types/release-changelog";
import { BackofficeUser } from "../../../../services/release-admin/types/backoffice-user";
import { ReleaseNote } from "../../../../services/release-admin/types/release-note";
import { ReleaseIndexSchema } from "../../../../services/search-admin/types/index-schema/release-index-schema";

const callAPI = CallApi("release-admin");

export const getProfile = async (): Promise<BackofficeUser> => {
  const url = "/me";

  const response = await callAPI(url, "GET");

  return handleJSONResponse(response);
};

export const listUsers = async (): Promise<PageResult<BackofficeUser>> => {
  const url = "/users";

  const response = await callAPI(url, "GET");

  return handleJSONResponse(response);
};

export const listChangelog = async (
  releaseId: string,
  next?: string
): Promise<PageResult<ReleaseChangelog>> => {
  const url = `/changelog/${releaseId}?page=${next || ""}`;

  const response = await callAPI(url, "GET");

  return handleJSONResponse(response);
};

export const listNotes = async (
  releaseId: string,
  next?: string
): Promise<PageResult<ReleaseNote>> => {
  const url = `/notes/${releaseId}?page=${next || ""}`;

  const response = await callAPI(url, "GET");

  return handleJSONResponse(response);
};

export const createNote = async (
  releaseId: string,
  entry: string,
  watchlistNote: boolean = false
): Promise<ReleaseNote> => {
  const url = `/notes/${releaseId}`;

  const response = await callAPI(url, "POST", { entry, watchlistNote });

  return handleJSONResponse(response);
};

export const updateNote = async (
  note: ReleaseNote,
  entry: string
): Promise<ReleaseNote> => {
  const url = `/notes`;

  const response = await callAPI(url, "PUT", { ...note, entry });

  return handleJSONResponse(response);
};

export const deleteNote = async (
  releaseId: string,
  userId: string,
  created_at: Date,
  watchlistNote: boolean = false
): Promise<Boolean> => {
  const url = `/notes/delete`;

  const response = await callAPI(url, "POST", {
    releaseId,
    userId,
    created_at,
    watchlistNote
  });

  return response.ok;
};

export const validateAssignment = async (
  releaseId: string
): Promise<boolean> => {
  const url = `/assignment/${releaseId}`;

  const response = await callAPI(url, "GET");

  return response.ok;
};

export const transferRelease = async (
  releaseId: string,
  userId: string
): Promise<boolean> => {
  const url = `/assignment/${releaseId}/${userId}`;

  const response = await callAPI(url, "PUT");

  return response.ok;
};

export const listByStatus = async (
  status: AdminReleaseStatus,
  next?: string
): Promise<PageResult<ReleaseIndexSchema>> => {
  const url = `/status/${status}?page=${next || ""}`;

  const response = await callAPI(url, "GET");

  return handleJSONResponse(response);
};

export const agentView = async (
  agentId: string,
  next?: string
): Promise<PageResult<ReleaseIndexSchema>> => {
  const url = `/agent/${agentId}?page=${next || ""}`;

  const response = await callAPI(url, "GET");

  return handleJSONResponse(response);
};

export const agentChangelog = async (
  email: string,
  next?: string
): Promise<ReleaseChangelogResp> => {
  const url = `/agent/log/${btoa(email)}?page=${next || ""}`;

  const response = await callAPI(url, "GET");

  return handleJSONResponse(response);
};

export const getTotal = async (
  status: AdminReleaseStatus
): Promise<{ total: number }> => {
  const url = `/total/${status}`;

  const response = await callAPI(url, "GET");

  return handleJSONResponse(response);
};

export const assignBatch = async (): Promise<AdminRelease[]> => {
  const url = `/assignment`;

  const response = await callAPI(url, "POST");

  return handleJSONResponse(response);
};
